import styled from 'styled-components';

import { flexAsColumn } from '@components/Styled/mixins';
import { Text } from '@components';

const UnlockLayout = styled.section`
  ${flexAsColumn(4)}

  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2)};

  > * {
    width: auto;
  }

  > div {
    ${flexAsColumn(2)}

    align-items: center;
  }

  > form {
    ${flexAsColumn(2)}

    align-items: center;

    > * {
      width: auto;
    }

    > div {
      ${flexAsColumn(1)}

      align-items: center;

      > button:last-of-type {
        display: none;
      }
    }
  }
`;

const VPNErrorMessage = styled(Text)`
  color: ${({ theme }) => theme.palette.danger.main};
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.palette.danger.main};
`;

export { ErrorMessage, UnlockLayout, VPNErrorMessage };
